<template>
  <v-main>
  </v-main>
</template>

<script>
import { Auth, Logger } from 'aws-amplify';

const logger = new Logger('login');

export default {
  name: 'Login',
  async created() {
    logger.info('created', this.$route.query.code);

    // OAuthのリダイレクトの場合は、認証処理を呼び出さない
    // query parameterにcodeが存在するかで判定する
    if (!this.$route.query.code) {
      // 認証処理
      const result = await Auth.federatedSignIn({
        provider: 'HENNGE',
      });
      logger.info('federated sign in', result);
    }
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>